import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { updateQuote as updateQuoteApi, UpdateQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { chain, CheckExpirationDate } from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/SubmitQuote";
import submitQuote from "@insite/client-framework/Store/Pages/RfqQuoteDetails/Handlers/SubmitQuote";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        quote: QuoteModel;
    } & HasOnSuccess &
        HasOnError<string>,
    UpdateQuoteApiParameter,
    QuoteModel
>;

export const CheckExpirationDateUpdate: HandlerType = props => {};

replaceInChain(chain, CheckExpirationDate, CheckExpirationDateUpdate);
